export default __webpack_public_path__ + "static/media/HeadshotSQ.3fcb36fb.jpg";